export default "__VITE_ASSET__TXg3tMdP__"